import {Dispatch, SetStateAction, useCallback, useState} from "react";

export default function useBoolState(initialValue: boolean): [boolean, () => void, Dispatch<SetStateAction<boolean>>] {
    const [value, setValue] = useState<boolean>(initialValue);
    const toggleValue = useCallback(() => {
        setValue(v => !v);
    }, []);
    return [value, toggleValue, setValue];
}
